import React from "react";
import { ColoredSpan } from "../../components";
import { ModalHelpLabel } from "../../components/inspection-status";
import { ModalHelp } from "../../components/modal";

const InspectionStatusModalHelp = ({
  openModal,
  setOpenModal,
  inspectionSymbol,
}) => {
  return (
    <ModalHelp openModal={openModal} setOpenModal={setOpenModal} size="lg">
      <div className="flex justify-center p-2">
        <table className="table-auto border-collapse">
          <thead>
            <tr>
              <th></th>
              <th className="border border-[#616161] bg-[#E0E0E0] p-0 w-[80px] h-[24px] flex">
                <div className="w-full">
                  <span>点</span>
                </div>
                <div className="w-full">
                  <span>承</span>
                </div>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <ModalHelpLabel text="点検結果OK" position="left" />
              <td className="border-x border-b border-[#616161] p-0 h-10 w-[80px] flex">
                <div className="w-full justify-center items-center">
                  <ColoredSpan
                    className="flex h-full justify-center items-center"
                    color={inspectionSymbol.passed.color}
                    background={inspectionSymbol.passed.background}
                  >
                    {inspectionSymbol.passed.symbol}
                  </ColoredSpan>
                </div>
                <div className="w-full">
                  <ColoredSpan
                    className="flex h-full justify-center items-center"
                    color={inspectionSymbol.passed.color}
                    background={inspectionSymbol.passed.background}
                  >
                    {inspectionSymbol.passed.symbol}
                  </ColoredSpan>
                </div>
              </td>
              <ModalHelpLabel text="全ての承認が完了" position="right" />
            </tr>
            <tr>
              <ModalHelpLabel text="点検結果NGあり" position="left" />
              <td className="border-x border-b border-[#616161] p-0 h-10 w-[80px] flex">
                <div className="w-full">
                  <ColoredSpan
                    className="w-full h-full flex justify-center items-center"
                    color={inspectionSymbol.failed.color}
                    background={inspectionSymbol.failed.background}
                  >
                    {inspectionSymbol.failed.symbol}
                  </ColoredSpan>
                </div>
                <div className="w-full">
                  <ColoredSpan
                    className="w-full h-full flex justify-center items-center"
                    color={inspectionSymbol.failed.color}
                    background={inspectionSymbol.failed.background}
                  >
                    {inspectionSymbol.failed.symbol}
                  </ColoredSpan>
                </div>
              </td>
              <ModalHelpLabel text="承認が未完了" position="right" />
            </tr>
            <tr>
              <ModalHelpLabel text="未点検" position="left" />
              <td className="border-x border-b border-[#616161] p-0 h-10 w-[80px] flex">
                <div className="w-full">
                  <ColoredSpan
                    className="w-full h-full flex justify-center items-center"
                    color={inspectionSymbol.not_inspected.color}
                    background={inspectionSymbol.not_inspected.background}
                  >
                    {inspectionSymbol.not_inspected.symbol}
                  </ColoredSpan>
                </div>
                <div className="w-full">
                  <ColoredSpan
                    className="w-full h-full flex justify-center items-center"
                    color={inspectionSymbol.not_inspected.color}
                    background={inspectionSymbol.not_inspected.background}
                  >
                    {inspectionSymbol.not_inspected.symbol}
                  </ColoredSpan>
                </div>
              </td>
              <ModalHelpLabel text="未承認" position="right" />
            </tr>
            <tr>
              <ModalHelpLabel text="処置完了済" position="left" />
              <td className="border-x border-b border-[#616161] p-0 h-10 w-[80px] flex">
                <div className="w-full">
                  <ColoredSpan
                    className="w-full h-full flex justify-center items-center"
                    color={inspectionSymbol.treatment_completed.color}
                    background={inspectionSymbol.treatment_completed.background}
                  >
                    {inspectionSymbol.treatment_completed.symbol}
                  </ColoredSpan>
                </div>
                <div className="w-full">
                  <ColoredSpan
                    className="w-full h-full flex justify-center items-center"
                    color={inspectionSymbol.failed.color}
                    background={inspectionSymbol.failed.background}
                  >
                    {inspectionSymbol.failed.symbol}
                  </ColoredSpan>
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <ModalHelpLabel text="OKNG対象外" position="left" />
              <td className="border-x border-b border-[#616161] p-0 h-10 w-[80px] flex">
                <div className="w-full">
                  <ColoredSpan
                    className="w-full h-full flex justify-center items-center"
                    color={inspectionSymbol.other_okng.color}
                    background={inspectionSymbol.other_okng.background}
                  >
                    {inspectionSymbol.other_okng.symbol}
                  </ColoredSpan>
                </div>
                <div className="w-full">
                  <ColoredSpan
                    className="w-full h-full flex justify-center items-center"
                    color={inspectionSymbol.failed.color}
                    background={inspectionSymbol.failed.background}
                  >
                    {inspectionSymbol.failed.symbol}
                  </ColoredSpan>
                </div>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ModalHelp>
  );
};

export default InspectionStatusModalHelp;
